import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { GoogleAddressComponent } from '/@/modules/core/geo/models/GoogleAddressComponent';
import { GooglePlaceDetailType } from '/@/modules/core/geo/GooglePlaceDetailType';

export class GooglePlaceDetails extends BaseModel {
  /**
   * @var {Array.<GoogleAddressComponent>}
   */
  addressComponents;

  /**
   * @var {string}
   */
  formattedAddress;

  /**
   * @var {String}
   */
  description;

  constructor(model = {}) {
    super();

    /**
     * @var {Array.<GoogleAddressComponent>} address_components
     */
    this.addressComponents = GoogleAddressComponent.mapModels(model.address_components);
    /**
     * @var {string} formatted_address
     */
    this.formattedAddress = model.formatted_address;
    this.description = model.description;
  }

  /**
   * @returns {string}
   */
  get postalCode() {
    return this.findAddressComponentByType(GooglePlaceDetailType.POSTAL_CODE);
  }

  /**
   * @returns {string}
   */
  get city() {
    return this.findAddressComponentByType(GooglePlaceDetailType.LOCALITY);
  }

  get streetAddress() {
    let stAddress = '';
    if (this.streetNumber) {
      stAddress = `${stAddress}${this.streetNumber} `;
    }
    if (this.streetName) {
      stAddress = `${stAddress}${this.streetName}`;
    }
    return stAddress;
  }

  /**
   * @returns {string}
   */
  get streetName() {
    return this.findAddressComponentByType(GooglePlaceDetailType.ROUTE);
  }

  /**
   * @returns {string}
   */
  get streetNumber() {
    return this.findAddressComponentByType(GooglePlaceDetailType.STREET_NUMBER);
  }

  /**
   * @returns {string}
   */
  get aptNumber() {
    return (
      this.findAddressComponentByType(GooglePlaceDetailType.ROOM) ||
      this.findAddressComponentByType(GooglePlaceDetailType.SUBPREMISE) ||
      this.findAddressComponentByType(GooglePlaceDetailType.FLOOR) ||
      this.findAddressComponentByType(GooglePlaceDetailType.ESTABLISHMENT)
    );
  }

  /**
   * @returns {string}
   */
  get county() {
    return this.findAddressComponentByType(GooglePlaceDetailType.ADMINISTRATIVE_AREA_LEVEL_2);
  }

  /**
   * @returns {string}
   */
  get jurisdiction() {
    return this.findAddressComponentByType(GooglePlaceDetailType.ADMINISTRATIVE_AREA_LEVEL_1);
  }

  /**
   * @returns {string}
   */
  get country() {
    return this.findAddressComponentByType(GooglePlaceDetailType.COUNTRY);
  }

  /**
   * @returns {string}
   */
  get fullAddress() {
    return this.description;
  }

  /**
   * @returns {string}
   */
  findAddressComponentByType(type) {
    return (
      this.addressComponents.find((addressComponent) => addressComponent.types.includes(type))
        ?.longName ?? null
    );
  }
}
